// Reserve the widest left rail and the smallest right control hit area,
// including their screen-edge inset and a gap from the reading column.
export function marginDockFits(viewportWidth, { left, right }) {
  const edge = Math.min(30, Math.max(18, viewportWidth * 0.024));
  const gap = 16;
  return left >= edge + 108 + gap
    && viewportWidth - right >= edge + 84 + gap;
}
